import { render, staticRenderFns } from "./maintenancelist.vue?vue&type=template&id=507a2aa2&scoped=true&"
import script from "./maintenancelist.vue?vue&type=script&lang=js&"
export * from "./maintenancelist.vue?vue&type=script&lang=js&"
import style0 from "./maintenancelist.vue?vue&type=style&index=0&id=507a2aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a2aa2",
  null
  
)

export default component.exports